import {Mapper} from '@s-ui/domain'

export default class FromVersionSearchUrlParamToSearchCodeValueObjectMapper extends Mapper {
  constructor({valueObject}) {
    super()
    this._valueObject = valueObject
  }

  _parseVersionSearchUrlParam = ({searchUrlParam} = {}) => {
    const HP_REGEX = /(?<hp>\d+)cv/
    const matchedParts = searchUrlParam.match(HP_REGEX)
    const {hp} = matchedParts?.groups || {}

    return {hp: Number(hp)}
  }

  map = ({searchUrlParam}) => {
    const searchCode = this._parseVersionSearchUrlParam({searchUrlParam})
    return this._valueObject({searchCode})
  }
}
